module.exports = __webpack_public_path__ + "media/images/placeholder-square-a9473d14.png";